module.exports = __webpack_public_path__ + "static/img/MV3.28f03d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/MV3.jpg
// module id = aBUt
// module chunks = 0